export default __webpack_public_path__ + "static/media/pic2.347d5db6.jpg";